import { createLeadAssistant } from '@quero/qb-partials/src/javascripts/components/lead_assistant'

createLeadAssistant()
